import { PartnerStateContext } from 'contexts/partner_state_context';
import React, { useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { PartnerRouteHelper } from 'routes/partner';

const PartnerInstrumentSharingRoute = () => {
  const partnerState = useContext(PartnerStateContext);
  const location = useLocation();
  const isSharing = partnerState.currentDealer.authority?.enableInstrumentSharing ?? false;

  return isSharing ? (
    <div>
      <Outlet />
    </div>
  ) : (
    <Navigate to={PartnerRouteHelper.login()} state={{ from: location }} replace />
  );
};

export default PartnerInstrumentSharingRoute;
